/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { logOut } from '../../../../../../app/auth/auth.actions';
import { authSelectors } from '../../../../../../app/auth/auth.selectors';
import { useSelect } from '../../../../../../utils/selector.utils';
import { useToggler } from '../../../../../../utils/toggler.utils';
import { UserDetails } from './UserDetails';
import { MdWorkspacesFilled } from 'react-icons/md';
import { FaUser } from 'react-icons/fa6';
import { RiShutDownLine } from 'react-icons/ri';

export const Settings: FunctionComponent = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const loggedUserId = useSelect(authSelectors.selectLoggedUser);
  const isLoggedUserAdmin = useSelector(authSelectors.selectUserIsAdmin);

  const [isToggledPanel, handleTogglePanel] = useToggler();
  const handleLogout = useCallback(() => {
    dispatch(logOut());
  }, [dispatch]);

  const handleMyProfileClick = useCallback(() => {
    history.push('/settings/profile');
  }, [history]);

  const handleSettingsClick = useCallback(() => {
    history.push('/settings');
  }, [history]);

  return (
    <li className={`dropdown ${!isToggledPanel ? 'opened' : ''}`}>
      <a style={{ cursor: 'pointer' }} className="panel-button dropdown-button" onClick={handleTogglePanel}>
        <i className="icon-settings"></i>
        <i className="icon-down-dir"></i>
      </a>
      <ul className="dropdown-menu settings-menu drop-right" onMouseLeave={handleTogglePanel}>
        <li>{loggedUserId && <UserDetails userId={loggedUserId} />}</li>
        <li>
          <a style={{ cursor: 'pointer' }} className="drop-item" onClick={handleMyProfileClick}>
            <FaUser size={14} className="mr-1 blueGray" /> My profile
          </a>
        </li>
        <li>
          <a style={{ cursor: 'pointer' }} className="drop-item" onClick={() => history.push('/workspaces')}>
            <MdWorkspacesFilled size={14} className="mr-1 blueGray" /> Workspaces
          </a>
        </li>
        {/* {isLoggedUserAdmin && (
          <li>
            <a style={{ cursor: 'pointer' }} className="drop-item" onClick={handleSettingsClick}>
              <i className="icon-settings blueGray mr-1"></i> Settings
            </a>
          </li>
        )} */}
        <li>
          <a style={{ cursor: 'pointer' }} className="drop-item" onClick={handleLogout}>
            <RiShutDownLine size={14} className="blueGray mr-1" /> Logout
          </a>
        </li>
        {/* <li className="noClick" onClick={(e) => e.stopPropagation()}>
          <div className="drop-item darkGray">
            <label className="switch mr-1">
              <input type="checkbox" className="switch-input change-theme" />
              <span className="switch-label"></span>
              <span className="switch-handle"></span>
            </label>
            Light theme
          </div>
        </li> */}
      </ul>
    </li>
  );
};
